/*
 * Copyright © 2018-2026, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { CreateInventoryItemForm } from "../InventoryItemForm";
import { strings } from "../../../../common/Strings/Strings";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import { ChevronDown } from "../../../../common/Icons/ChevronDown";
import { CheckSimple } from "../../../../common/Icons/CheckSimple";
import { CheckCircle } from "../../../../common/Icons/CheckCircle";
import { PauseCircle } from "../../../../common/Icons/PauseCircle";

const ActiveStatusSelect: React.FC = () => {
  const [isDropdown, setIsDropdown] = useState<boolean>(false);
  const { control } = useFormContext<CreateInventoryItemForm>();

  return (
    <Controller
      name="active"
      control={control}
      render={({ field }) => (
        <Dropdown className="w-full">
          <Dropdown.Toggle>
            <div
              className="tw-card w-full flex justify-between items-center p-3 cursor-pointer"
              onClick={() => {
                setIsDropdown(!isDropdown);
              }}
              role="button"
              tabIndex={0}
            >
              <div className="flex items-center w-full space-x-2">
                <div className="">
                  {field.value !== false ? (
                    <CheckCircle className="flex-shrink-0 w-6 h-6 text-sky-500" />
                  ) : (
                    <PauseCircle className="flex-shrink-0 w-6 h-6 text-gray-300" variant="solid" />
                  )}
                </div>
                <div className="font-bold grow">
                  {field.value !== false
                    ? strings.activeStatusActiveDescription
                    : strings.activeStatusInactiveDescription}
                </div>
                <div className="ml-auto">
                  <ChevronDown className="w-6 h-6 text-slate-500 dark:text-slate-400 shrink-0" />
                </div>
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Content>
            <li
              className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white cursor-pointer"
              onClick={() => {
                field.onChange(true);
                setIsDropdown(false);
              }}
            >
              <div className="flex w-full">
                <div>{strings.activeStatusActive}</div>
                {field.value !== false && (
                  <div className="ml-auto">
                    <CheckSimple />
                  </div>
                )}
              </div>
            </li>
            <li
              className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white cursor-pointer"
              onClick={() => {
                field.onChange(false);
                setIsDropdown(false);
              }}
            >
              <div className="flex w-full">
                <div>{strings.activeStatusInactive}</div>
                {field.value === false && (
                  <div className="ml-auto">
                    <CheckSimple />
                  </div>
                )}
              </div>
            </li>
          </Dropdown.Content>
        </Dropdown>
      )}
    />
  );
};

export default ActiveStatusSelect;
